import { ReactNode, useState } from "react";

interface IFieldProps {
    isExpanded?: boolean;
    children: ReactNode;
}

export default function Title(props: IFieldProps) {

    const [isExpanded, setIsExpanded] = useState(props?.isExpanded === undefined ? true : props.isExpanded);

    const onExpandClick = () => {
        setIsExpanded(!isExpanded);
    }

    return (
        <span className={"title " + (isExpanded ? "expanded":"collapsed")} onClick={onExpandClick} >
            {props.children}
        </span>
    );
}